<div
  fxShow
  fxHide.gt-sm
  fxLayout="row"
  fxLayoutAlign="center center"
  class="header-contact"
>
  <div
    class="contact-trigger"
    [class.clicked]="isOpen"
    [ngClass]="{ 'invisible': !isVisible }"
  >
    <button
      mat-raised-button
      color="black"
      class="contact-trigger-button"
      (click)="isOpen = !isOpen"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="sidebar_click"
      appFbqEvent="Contact"
      [customData]="{content_name: 'sidebar_click', content_category: 'click'}"
    >
      Află mai multe
    </button>
  </div>
  <div
    [class.open]="isOpen"
    class="form-container"
  >
    <app-contact-form-base *ngIf="isOpen"></app-contact-form-base>
    <button
      mat-raised-button
      class="contact-trigger-button"
      (click)="isOpen = false"
    >
      Închide
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/expandable-contact-form/expandable-contact-form-mobile.component.html